import { render, staticRenderFns } from "./SecaoSolucao.vue?vue&type=template&id=73301d8d&scoped=true"
import script from "./SecaoSolucao.vue?vue&type=script&lang=js"
export * from "./SecaoSolucao.vue?vue&type=script&lang=js"
import style0 from "./SecaoSolucao.vue?vue&type=style&index=0&id=73301d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73301d8d",
  null
  
)

export default component.exports